import React, { useContext, useEffect, useState } from "react";
import { isDateFinalized, minutesToHour, setDateHelper, userDetails } from "../../utils/Helper";
import ReactSelect from "react-select";
import DatePicker from "react-datepicker";
import calLogo from '../../assets/images/calender.svg'
import Button from "../../components/ui/Button";
import { useForm } from "react-hook-form";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';
import ValidationMessage from "../../constants/ValidationMessage";
import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";
import Select from "react-select";
import toast from "react-hot-toast";
import Checkbox from "../../components/layouts/CheckBox";

interface choresUpdateInputs {
    selectedChores: string[]
    date?: string;
    d_by?: object | null;
    h_spent: string;
    m_date: string;
    new_date?: string;
    description?: string;
    status?: object | null;
    cc_id?: string;
};

const EditAllChores = ({ selectedChores, choresOptions, doneByOptions, expensesCategories, editChores, onSuccess, onCancel, finalizedMonths }: any) => {
    console.log("editChores: ", editChores)
    let profile: any = useContext(authContext);
    profile = profile?.data;
    const updateChores = useMakeRequest();
    const [choresFilter, setChoresFilter] = useState<any>();
    const [checkboxStates, setCheckboxStates] = useState({
        editDate: true,
        editStatus: true,
        editMember: true,
        editHours: true,
        editDescription: true,
        editChore: true,
    });

    const getSchema = (checks: any) =>
        yup.object().shape({
            h_spent: checks.editHours
                ? yup.string()
                    .test(
                        "h_spent-required",
                        ValidationMessage.Field("a value greater than 0"),
                        function (value) {
                            return Number(value) > 0;
                        }
                    )
                : yup.string().nullable(),

            new_date: checks.editDate
                ? yup.string().required("Please select a date")
                : yup.string().nullable(),

            d_by: checks.editMember
                ? yup.object().nullable().required("Select a member")
                : yup.object().nullable(),

            status: checks.editStatus
                ? yup.object().nullable().required("Select a status")
                : yup.object().nullable(),

            cc_id: checks.editChore
                ? yup.string().required("Select a chore")
                : yup.string().nullable(),

            description: checks.editDescription
                ? yup.string().max(200, "Description must be less than 200 characters")
                : yup.string().nullable(),
        });

    const { register, watch, setValue, getValues, formState: { errors }, handleSubmit, trigger, reset } = useForm<choresUpdateInputs>({
        mode: 'onChange',
        resolver: yupResolver(getSchema(checkboxStates)) as any
    });

    useEffect(() => {
        const modal = document.getElementById("editAllChoresUpdateModal");

        const handleOpen = () => {
            reset({
                h_spent: "",
                new_date: "",
                date: "",
                d_by: null,
                status: null,
                cc_id: "",
                description: "",
            });

            setCheckboxStates({
                editChore: true,
                editDate: true,
                editDescription: true,
                editHours: true,
                editMember: true,
                editStatus: true,
            });

            setChoresFilter(undefined);
        };

        const handleBackdropClick = (e: any) => {
            if (e.target === modal) {
                $('.btn-close-modal').click();
            }
        };

        modal?.addEventListener("shown.bs.modal", handleOpen);
        modal?.addEventListener("click", handleBackdropClick);

        return () => {
            modal?.removeEventListener("shown.bs.modal", handleOpen);
            modal?.removeEventListener("click", handleBackdropClick);
        };
    }, []);

    const onSubmit = (payload: any) => {
        console.log("payload: ==", payload)

        $('.btn-close-modal').click();
        const is_finalized = isDateFinalized(payload?.new_date, finalizedMonths || []);
        if (is_finalized) {
            toast.error("Selected date already finalized.")
            return;
        }
        console.log("editChores: ", editChores)
        const updatedArray = editChores.map((item: any) => {
            let updatedItem: any = {
                ...item,
                is_deleted: 0,
                h_spent: `${item?.h_spent}`,
                c_id: item.c_id,
                new_date: null
            };

            if (checkboxStates.editMember) {
                updatedItem.d_by = payload.status ? payload.status.value !== 1 ? payload.d_by?.value : "" : payload.d_by?.value;
            }
            if (checkboxStates.editDate) {
                updatedItem.new_date = payload?.date === payload?.new_date ? null : payload?.new_date;
            }
            if (checkboxStates.editDescription) {
                updatedItem.description = payload?.description ?? '';
            }
            if (checkboxStates.editStatus) {
                updatedItem.status = payload.status.value;
            }
            if (checkboxStates.editHours) {
                updatedItem.h_spent = payload.h_spent;
            }
            if (checkboxStates.editChore) {
                updatedItem.cc_id = payload?.cc_id || item.cc_id;
            }

            return updatedItem;
        });

        console.log("updatedArray: ", updatedArray)
        updateChores.makeRequest({
            url: ApiConstants?.AllChoresUpdate,
            payload: updatedArray
        });
    }

    useEffect(() => {
        if (updateChores?.status) {
            onSuccess();
            reset();
            trigger();

            setChoresFilter(undefined); // ✅ clear select value

            setCheckboxStates({
                editChore: true,
                editDate: true,
                editDescription: true,
                editHours: true,
                editMember: true,
                editStatus: true
            });

            setValue("cc_id", "");

            toast.success("Chores updated successfully.");
            $('.btn-close-modal').click();
        }
    }, [updateChores?.status]);

    console.log("cc_id: ", watch('cc_id'))

    return (
        <div className="modal fade bottom-sheet-modal" id="editAllChoresUpdateModal" tabIndex={-1} aria-labelledby="editAllChoresUpdateModalLabel" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    {/* Bottom Sheet Handle */}
                    <div className="bottom-sheet-handle">
                        <div className="handle-bar"></div>
                    </div>

                    <div className="modal-header">
                        <h1 className="modal-title" id="editAllChoresUpdateModalLabel">Edit Chores</h1>
                        <span className="modal-description"
                        >
                            If a box is checked, the field will be changed for all chores selected. If a box is not checked, the field will not be changed.
                        </span>
                    </div>



                    <div className="modal-body">
                        <form className="row gy-3" onSubmit={handleSubmit(onSubmit)}>

                            <div className="col-12">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_chore"}
                                        labelText={"Edit Chore"}
                                        checked={checkboxStates.editChore}
                                        onChange={() =>
                                            setCheckboxStates((prev) => ({ ...prev, editChore: !prev.editChore }))
                                        }
                                    />
                                    {/* <div className="d-flex align-items-center gap-2 mb-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            onClick={(e) => e.stopPropagation()}
                                            checked={checkboxStates.editChore}
                                            onChange={() =>
                                                setCheckboxStates((prev) => ({ ...prev, editChore: !prev.editChore }))
                                            }
                                        />
                                        <label className="form-label mb-0">Edit Chore</label>
                                    </div> */}
                                    <div className='custom-select'>
                                        <ReactSelect
                                            value={
                                                watch("cc_id")
                                                    ? choresOptions.find((o: any) => o.value === watch("cc_id"))
                                                    : null
                                            }
                                            options={[...choresOptions]}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Select"
                                            isDisabled={!checkboxStates.editChore}
                                            onChange={(selectedOption: any) => {
                                                setChoresFilter({ ...choresFilter, cc_id: selectedOption })
                                                setValue("cc_id", selectedOption?.value || "");
                                                trigger("cc_id");
                                            }}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="cc_id"
                                            render={({ message }) => <p className='valid-error'>{message}</p>}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='col-6'>
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_date"}
                                        labelText={"Edit Date"}
                                        checked={checkboxStates.editDate}
                                        onChange={() =>
                                            setCheckboxStates((prev) => ({ ...prev, editDate: !prev.editDate }))
                                        }
                                    />
                                    {/* <div className="d-flex align-items-center gap-2 mb-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            onClick={(e) => e.stopPropagation()}
                                            checked={checkboxStates.editDate}
                                            onChange={() =>
                                                setCheckboxStates((prev) => ({ ...prev, editDate: !prev.editDate }))
                                            }
                                        />
                                        <label className="form-label mb-0">Edit Date</label>
                                    </div> */}
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="MM/DD/YYYY"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={watch('new_date') ? moment(watch('new_date')).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setValue('new_date', setDateHelper({ date: start_date }))
                                            trigger('new_date')
                                        }}
                                        disabled={!checkboxStates.editDate}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="new_date"
                                        render={({ message }) => <p className='valid-error'>{message}</p>}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="com-input-grp">

                                    <Checkbox
                                        id={"edit_hours"}
                                        labelText={"Edit Hours"}
                                        checked={checkboxStates.editHours}
                                        onChange={() =>
                                            setCheckboxStates((prev) => ({ ...prev, editHours: !prev.editHours }))
                                        }
                                    />
                                    {/* <div className="d-flex align-items-center gap-2 mb-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            onClick={(e) => e.stopPropagation()}
                                            checked={checkboxStates.editHours}
                                            onChange={() =>
                                                setCheckboxStates((prev) => ({ ...prev, editHours: !prev.editHours }))
                                            }
                                        />
                                        <label className="form-label mb-0">Edit Hours</label>
                                    </div> */}
                                    <div className='custom-select'>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder='Hours spent'
                                            max={24}
                                            min={0}
                                            value={watch('h_spent')}
                                            disabled={!checkboxStates.editHours}
                                            onInput={(e: any) => {
                                                let value = e.target.value.replace(/[^0-9.]/g, '');
                                                if (value === '') {
                                                    setValue('h_spent', '');
                                                    trigger('h_spent');
                                                    return;
                                                }
                                                const [hours, minutes] = value.split('.');
                                                if (parseInt(hours) > 24) {
                                                    value = '24';
                                                }
                                                if (minutes) {
                                                    if (minutes.length > 2) {
                                                        value = `${hours}.${minutes.substring(0, 2)}`;
                                                    }
                                                    if (parseInt(minutes[0]) > 5) {
                                                        value = `${hours}.5`;
                                                    } else if (minutes.length === 2 && parseInt(minutes) > 59) {
                                                        value = `${hours}.59`;
                                                    }
                                                }
                                                e.target.value = value;
                                                setValue('h_spent', value);
                                                trigger('h_spent');
                                            }}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="h_spent"
                                            render={({ message }) => <p className='valid-error'>{message}</p>}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_status"}
                                        labelText={"Edit Status"}
                                        checked={checkboxStates.editStatus}
                                        onChange={() =>
                                            setCheckboxStates((prev) => ({ ...prev, editStatus: !prev.editStatus }))
                                        }
                                    />
                                    {/* <div className="d-flex align-items-center gap-2 mb-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            onClick={(e) => e.stopPropagation()}
                                            checked={checkboxStates.editStatus}
                                            onChange={() =>
                                                setCheckboxStates((prev) => ({ ...prev, editStatus: !prev.editStatus }))
                                            }
                                        />
                                        <label className="form-label mb-0">Edit Status</label>
                                    </div> */}
                                    <div className="custom-select">
                                        <Select
                                            value={watch('status')}
                                            options={[{ value: 1, label: "Unassigned" }, { value: 2, label: "Assigned" }, { value: 3, label: "Completed" }]}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Select"
                                            isDisabled={!checkboxStates.editStatus}
                                            onChange={(selectedOption: any) => {
                                                if (selectedOption?.value == 1) {
                                                    setCheckboxStates((prev) => ({ ...prev, editMember: false }))
                                                }
                                                setValue("status", selectedOption);
                                                trigger("status");
                                            }}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="status"
                                            render={({ message }) => <p className='valid-error'>{message}</p>}
                                        />
                                    </div>
                                </div>
                            </div>
                            {(watch('status') as any)?.value !== 1 &&
                                <div className="col-6">
                                    <div className="com-input-grp">

                                        <Checkbox
                                            id={"edit_member"}
                                            labelText={"Edit Member"}
                                            checked={checkboxStates.editMember}
                                            onChange={() =>
                                                setCheckboxStates((prev) => ({ ...prev, editMember: !prev.editMember }))
                                            }
                                        />
                                        {/* <div className="d-flex align-items-center gap-2 mb-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            onClick={(e) => e.stopPropagation()}
                                            checked={checkboxStates.editMember}
                                            onChange={() =>
                                                setCheckboxStates((prev) => ({ ...prev, editMember: !prev.editMember }))
                                            }
                                        />
                                        <label className="form-label mb-0">Edit Member</label>
                                    </div> */}
                                        <div className="custom-select">
                                            <ReactSelect
                                                options={doneByOptions}
                                                value={watch('d_by')}
                                                className="com-r-select"
                                                classNamePrefix="com-r-select"
                                                placeholder="Member"
                                                isLoading={expensesCategories?.loading}
                                                isDisabled={!checkboxStates.editMember}
                                                onChange={(selectedOption: any) => {
                                                    setValue("d_by", selectedOption);
                                                    trigger("d_by");
                                                }}
                                            />
                                            <ErrorMessage
                                                errors={errors}
                                                name="d_by"
                                                render={({ message }) => <p className='valid-error'>{message}</p>}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }




                            <div className="col-12">
                                <div className="com-input-grp">
                                    <Checkbox
                                        id={"edit_description"}
                                        labelText={"Edit Description"}
                                        checked={checkboxStates.editDescription}
                                        onChange={() =>
                                            setCheckboxStates((prev) => ({ ...prev, editDescription: !prev.editDescription }))
                                        }
                                    />
                                    {/* <div className="d-flex align-items-center gap-2 mb-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            onClick={(e) => e.stopPropagation()}
                                            checked={checkboxStates.editDescription}
                                            onChange={() =>
                                                setCheckboxStates((prev) => ({ ...prev, editDescription: !prev.editDescription }))
                                            }
                                        />
                                        <label className="form-label mb-0">Edit Description</label>
                                    </div> */}
                                    <div className='custom-select'>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder='Type here'
                                            value={watch('description')}
                                            disabled={!checkboxStates.editDescription}
                                            onInput={(e: any) => {
                                                setValue('description', e.target.value);
                                                trigger('description');
                                            }}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="description"
                                            render={({ message }) => <p className='valid-error'>{message}</p>}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex gap-3 mt-4'>
                                <button
                                    className='custom-grayed-btn modal-light-btn btn-close-modal'
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    disabled={updateChores?.loading}
                                    type="button"
                                    onClick={onCancel}
                                    style={{ width: "50%" }}
                                >
                                    Cancel
                                </button>
                                <Button
                                    className='com-btn'
                                    type="submit"
                                    text="submit"
                                    loading={updateChores?.loading}
                                    style={{ width: "50%" }}
                                >
                                    Save
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditAllChores

// import React, { useContext, useEffect, useState } from "react";
// import { isDateFinalized, minutesToHour, setDateHelper, userDetails } from "../../utils/Helper";
// import ReactSelect from "react-select";
// import DatePicker from "react-datepicker";
// import calLogo from '../../assets/images/calender.svg'
// import Button from "../../components/ui/Button";
// import { useForm } from "react-hook-form";
// import authContext from "../../context/authContext";
// import useMakeRequest from "../../utils/ApiHelper";
// import { ApiConstants } from "../../constants/ApiConstants";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from 'yup';
// import ValidationMessage from "../../constants/ValidationMessage";
// import { ErrorMessage } from "@hookform/error-message";
// import moment from "moment";
// import Select from "react-select";
// import toast from "react-hot-toast";

// interface choresUpdateInputs {
//     selectedChores: string[]
//     date?: string;
//     d_by?: object | null; // Done by id
//     h_spent: string; // Hour spent
//     m_date: string;
//     new_date?: string;
//     description?: string;
//     status?: object | null;
//     cc_id?: string; // Chore category id
// };

// const EditAllChores = ({ selectedChores, choresOptions, doneByOptions, expensesCategories, editChores, onSuccess, onCancel, finalizedMonths }: any) => {
//     console.log("editChores: ", editChores)
//     let profile: any = useContext(authContext);
//     profile = profile?.data;
//     const updateChores = useMakeRequest();
//     const [choresFilter, setChoresFilter] = useState<any>();
//     const [checkboxStates, setCheckboxStates] = useState({
//         editDate: true,
//         editStatus: true,
//         editMember: true,
//         editHours: true,
//         editDescription: true,
//         editChore: true,
//     });

//     const getSchema = (checks: any) =>
//         yup.object().shape({
//             h_spent: checks.editHours
//                 ? yup.string()
//                     .test(
//                         "h_spent-required",
//                         ValidationMessage.Field("a value greater than 0"),
//                         function (value) {
//                             return Number(value) > 0;
//                         }
//                     )
//                 : yup.string().nullable(),  // no validation if checkbox is off

//             new_date: checks.editDate
//                 ? yup.string().required("Please select a date")
//                 : yup.string().nullable(),

//             d_by: checks.editMember
//                 ? yup.object().nullable().required("Select a member")
//                 : yup.object().nullable(),

//             status: checks.editStatus
//                 ? yup.object().nullable().required("Select a status")
//                 : yup.object().nullable(),

//             cc_id: checks.editChore
//                 ? yup.string().required("Select a chore")
//                 : yup.string().nullable(),

//             description: checks.editDescription
//                 ? yup.string().required("Description required")
//                 : yup.string().nullable(),
//         });



//     const { register, watch, setValue, getValues, formState: { errors }, handleSubmit, trigger, reset } = useForm<choresUpdateInputs>({
//         mode: 'onChange',
//         resolver: yupResolver(getSchema(checkboxStates)) as any
//     });

//     useEffect(() => {
//         const modal = document.getElementById("editAllChoresUpdateModal");

//         const handleOpen = () => {
//             reset({
//                 h_spent: "",
//                 new_date: "",
//                 date: "",
//                 d_by: null,
//                 status: null,
//                 cc_id: "",
//                 description: "",
//             });

//             setCheckboxStates({
//                 editChore: true,
//                 editDate: true,
//                 editDescription: true,
//                 editHours: true,
//                 editMember: true,
//                 editStatus: true,
//             });

//             setChoresFilter(undefined);
//         };

//         modal?.addEventListener("shown.bs.modal", handleOpen);

//         return () => modal?.removeEventListener("shown.bs.modal", handleOpen);
//     }, []);

//     const onSubmit = (payload: any) => {
//         console.log("payload: ==", payload)

//         $('.btn-close-modal').click();
//         const is_finalized = isDateFinalized(payload?.new_date, finalizedMonths || []);
//         if (is_finalized) {
//             toast.error("Selected date already finalized.")
//             return;
//         }
//         console.log("editChores: ", editChores)
//         const updatedArray = editChores.map((item: any) => {
//             let updatedItem: any = {
//                 ...item,
//                 is_deleted: 0,
//                 h_spent: `${item?.h_spent}`,
//                 c_id: item.c_id,
//                 new_date: null
//             };

//             if (checkboxStates.editMember) {
//                 updatedItem.d_by = payload.d_by?.value || "";
//             }
//             if (checkboxStates.editDate) {
//                 updatedItem.new_date = payload?.date === payload?.new_date ? null : payload?.new_date;
//             }
//             if (checkboxStates.editDescription) {
//                 updatedItem.description = payload?.description || item.description;
//             }
//             if (checkboxStates.editStatus) {
//                 updatedItem.status = payload.status.value;
//             }
//             if (checkboxStates.editHours) {
//                 updatedItem.h_spent = payload.h_spent;
//             }
//             if (checkboxStates.editChore) {
//                 updatedItem.cc_id = payload?.cc_id || item.cc_id;
//             }

//             return updatedItem;
//         });

//         console.log("updatedArray: ", updatedArray)
//         updateChores.makeRequest({
//             url: ApiConstants?.AllChoresUpdate,
//             payload: updatedArray
//         });
//     }
//     const getStatus = (status: number) => {
//         return status == 1 ? 'Unassigned' : status == 2 ? 'Assigned' : status == 3 ? 'Completed' : ""
//     }

//     // useEffect(() => {
//     //     if (editChores && doneByOptions?.length > 0) {
//     //         setValue('date', editChores?.date)
//     //         setValue('new_date', editChores?.date)
//     //         setValue('h_spent', editChores?.hour_spent)
//     //         setValue('m_date', editChores?.date)
//     //         setValue('status', {
//     //             value: editChores?.status,
//     //             label: getStatus(editChores?.status)
//     //         })
//     //         setValue('description', editChores?.description)
//     //         setValue('d_by', {
//     //             value: editChores?.done_by?.value,
//     //             label: profile?.uuid === editChores?.done_by?.value ? 'Me' : editChores?.done_by?.label
//     //         })


//     //         trigger('h_spent')
//     //     }
//     // }, [editChores, doneByOptions, expensesCategories])

//     useEffect(() => {
//         if (updateChores?.status) {
//             onSuccess()
//             reset()
//             trigger()
//             setCheckboxStates({
//                 editChore: true,
//                 editDate: true,
//                 editDescription: true,
//                 editHours: true,
//                 editMember: true,
//                 editStatus: true
//             })
//             toast.success("Chores updated successfully.")
//             $('.btn-close-modal').click();
//         }
//     }, [updateChores?.status])

//     return (
//         <div className="modal fade inner-modal com-modal" id="editAllChoresUpdateModal" tabIndex={-1} aria-labelledby="editAllChoresUpdateModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" >
//             <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" >
//                 <div className="modal-content">
//                     <div className="modal-header">
//                         <h1 className="modal-title" id="editAllChoresUpdateModalLabel">Edit Chores</h1>
//                     </div>
//                     <span className="form-title-control mt-2">
//                         Editing these fields will change the values for all chores selected.
//                     </span>
//                     <div className="modal-body">
//                         <form className="row gy-3" onSubmit={handleSubmit(onSubmit)}>
//                             <div className='col-12'>
//                                 <div className="com-input-grp">
//                                     <input
//                                         type="checkbox"
//                                         className="form-check-input"
//                                         onClick={(e) => e.stopPropagation()}
//                                         checked={checkboxStates.editDate}
//                                         onChange={() =>
//                                             setCheckboxStates((prev) => ({ ...prev, editDate: !prev.editDate }))
//                                         }
//                                     />
//                                     <label className="form-label">Edit Date</label>
//                                     <DatePicker
//                                         className='form-control'
//                                         placeholderText="MM/DD/YYYY"
//                                         timeFormat="MM DD YYYY"
//                                         onKeyDown={(e: any) => e.preventDefault()}
//                                         showYearDropdown
//                                         scrollableYearDropdown
//                                         yearDropdownItemNumber={50}
//                                         // selected={watch("s_date") as any}
//                                         selected={watch('new_date') ? moment(watch('new_date')).toDate() : null}
//                                         showIcon
//                                         icon={<><img className="calIcon" src={calLogo} alt="" /></>}
//                                         onChange={(start_date: any) => {
//                                             setValue('new_date', setDateHelper({ date: start_date }))
//                                             trigger('new_date')
//                                         }}
//                                     // minDate={moment(profile?.hh_member?.billing_date).toDate()}
//                                     />

//                                     <ErrorMessage
//                                         errors={errors}
//                                         name="s_date"
//                                         render={({ message }) => <p className='valid-error'>{message}</p>}
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-6">
//                                 <div className="com-input-grp">
//                                     <input
//                                         type="checkbox"
//                                         className="form-check-input"
//                                         onClick={(e) => e.stopPropagation()}
//                                         checked={checkboxStates.editStatus}
//                                         onChange={() =>
//                                             setCheckboxStates((prev) => ({ ...prev, editStatus: !prev.editStatus }))
//                                         }
//                                     />
//                                     <label className="form-label">Edit Status</label>
//                                     <div className="custom-select">
//                                         <Select
//                                             value={watch('status')}
//                                             options={[{ value: 1, label: "Unassigned" }, { value: 2, label: "Assigned" }, { value: 3, label: "Completed" },]}
//                                             className="com-r-select"
//                                             classNamePrefix="com-r-select"
//                                             placeholder="Select"
//                                             onChange={(selectedOption: any) => {
//                                                 setValue("status", selectedOption);
//                                                 trigger("d_by");
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-6">
//                                 <div className="com-input-grp">
//                                     <input
//                                         type="checkbox"
//                                         className="form-check-input"
//                                         onClick={(e) => e.stopPropagation()}
//                                         checked={checkboxStates.editMember}
//                                         onChange={() =>
//                                             setCheckboxStates((prev) => ({ ...prev, editMember: !prev.editMember }))
//                                         }
//                                     />
//                                     <label className="form-label">Edit Member</label>
//                                     <div className="custom-select">
//                                         <ReactSelect
//                                             options={doneByOptions}
//                                             value={watch('d_by')}
//                                             className="com-r-select"
//                                             classNamePrefix="com-r-select"
//                                             placeholder="Member"
//                                             isLoading={expensesCategories?.loading}
//                                             onChange={(selectedOption: any) => {
//                                                 setValue("d_by", selectedOption);
//                                                 trigger("d_by");
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-12">
//                                 <div className="com-input-grp">
//                                     <input
//                                         type="checkbox"
//                                         className="form-check-input"
//                                         onClick={(e) => e.stopPropagation()}
//                                         checked={checkboxStates.editHours}
//                                         onChange={() =>
//                                             setCheckboxStates((prev) => ({ ...prev, editHours: !prev.editHours }))
//                                         }
//                                     />
//                                     <label className="form-label">Edit Hours</label>
//                                     <div className='custom-select'>
//                                         <input type="text" className="form-control" placeholder='Hours spent' max={24} min={0} value={watch('h_spent')}
//                                             onInput={(e: any) => {
//                                                 let value = e.target.value.replace(/[^0-9.]/g, '');
//                                                 if (value === '') {
//                                                     setValue('h_spent', '');
//                                                     trigger('h_spent');
//                                                     return;
//                                                 }
//                                                 const [hours, minutes] = value.split('.');
//                                                 if (parseInt(hours) > 24) {
//                                                     value = '24';
//                                                 }
//                                                 if (minutes) {
//                                                     if (minutes.length > 2) {
//                                                         value = `${hours}.${minutes.substring(0, 2)}`;
//                                                     }
//                                                     if (parseInt(minutes[0]) > 5) {
//                                                         value = `${hours}.5`;
//                                                     } else if (minutes.length === 2 && parseInt(minutes) > 59) {
//                                                         value = `${hours}.59`;
//                                                     }
//                                                 }
//                                                 e.target.value = value;
//                                                 setValue('h_spent', value);
//                                                 trigger('h_spent');
//                                             }}
//                                         />
//                                         <ErrorMessage
//                                             errors={errors}
//                                             name="h_spent"
//                                             render={({ message }) => <p className='valid-error'>{message}</p>}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12">
//                                 <div className="com-input-grp">
//                                     <input
//                                         type="checkbox"
//                                         className="form-check-input"
//                                         onClick={(e) => e.stopPropagation()}
//                                         checked={checkboxStates.editChore}
//                                         onChange={() =>
//                                             setCheckboxStates((prev) => ({ ...prev, editChore: !prev.editChore }))
//                                         }
//                                     />
//                                     <label className="form-label">Edit Chore</label>
//                                     <div className='custom-select'>
//                                         <ReactSelect
//                                             value={choresFilter?.cc_id}
//                                             options={[{ value: '', label: 'All' }, ...choresOptions]}
//                                             className="com-r-select"
//                                             classNamePrefix="com-r-select"
//                                             placeholder="Select"
//                                             onChange={(selectedOption: any) => {
//                                                 setChoresFilter({ ...choresFilter, cc_id: selectedOption })
//                                                 setValue("cc_id", selectedOption ? selectedOption.value : "");
//                                                 trigger("cc_id")
//                                             }}
//                                         />
//                                         <ErrorMessage
//                                             errors={errors}
//                                             name="cc_id"
//                                             render={({ message }) => <p className='valid-error'>{message}</p>}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12">
//                                 <div className="com-input-grp">
//                                     <input
//                                         type="checkbox"
//                                         className="form-check-input"
//                                         onClick={(e) => e.stopPropagation()}
//                                         checked={checkboxStates.editDescription}
//                                         onChange={() =>
//                                             setCheckboxStates((prev) => ({ ...prev, editDescription: !prev.editDescription }))
//                                         }
//                                     />
//                                     <label className="form-label">Edit Description</label>
//                                     <div className='custom-select'>
//                                         <input type="text" className="form-control" placeholder='Type here' max={24} min={0} value={watch('description')}
//                                             onInput={(e: any) => {
//                                                 let value = e.target.value
//                                                 if (value === '') {
//                                                     setValue('description', '');
//                                                     trigger('description');
//                                                     return;
//                                                 }
//                                                 setValue('description', value);
//                                                 trigger('description');
//                                             }}
//                                         />
//                                         <ErrorMessage
//                                             errors={errors}
//                                             name="description"
//                                             render={({ message }) => <p className='valid-error'>{message}</p>}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className='page-padding-x pb-4 d-flex'>
//                                 <Button className='com-btn mt-2 me-4' style={{ width: "50%" }} type="submit" text="submit" loading={updateChores?.loading}>Save</Button>
//                                 <button className='com-btn com-btn-outline mt-2  btn-close-modal' style={{ width: "50%" }} data-bs-dismiss="modal" aria-label="Close" disabled={updateChores?.loading} type="button" onClick={onCancel}>Cancel</button>
//                             </div>
//                         </form>

//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default EditAllChores